// extracted by mini-css-extract-plugin
export var calendarView = "_mm-0";